var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("box", { staticClass: "_ov-h", attrs: { content: "" } }, [
    _c(
      "div",
      { staticClass: "_pa-2" },
      [
        _c(
          "base-compare-table",
          {
            attrs: {
              "primary-label": _vm.platformName,
              "secondary-label": "Kickstarter",
            },
          },
          [
            !_vm.isMobile
              ? _c("base-compare-row", {
                  attrs: { highlighted: "none" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "primary",
                        fn: function () {
                          return [
                            _c("themed-image", {
                              attrs: {
                                src: "/content/images/static/logo/site-logo.svg",
                                height: "20",
                                alt: _vm.platformName,
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "secondary",
                        fn: function () {
                          return [_c("strong", [_vm._v("Kickstarter")])]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    533669726
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _c("base-compare-row", {
              attrs: { first: "" },
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [_vm._v("Number of Payment Methods")]
                  },
                  proxy: true,
                },
                {
                  key: "primary",
                  fn: function () {
                    return [_vm._v("21")]
                  },
                  proxy: true,
                },
                {
                  key: "secondary",
                  fn: function () {
                    return [_vm._v("5")]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("base-compare-row", {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [_vm._v("Currency Conversion")]
                  },
                  proxy: true,
                },
                {
                  key: "primary",
                  fn: function () {
                    return [
                      _c("base-icon", {
                        staticClass: "_tc--accent",
                        attrs: { name: "check", size: "lg" },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "secondary",
                  fn: function () {
                    return [
                      _c("base-icon", { attrs: { name: "times", size: "lg" } }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("base-compare-row", {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [_vm._v("Availability of Installments")]
                  },
                  proxy: true,
                },
                {
                  key: "primary",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        [
                          _c("themed-image", {
                            attrs: {
                              src: "/content/images/static/stretch-pay/installments-logo.svg",
                              alt: "strechPay",
                              height: "16",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "gfu-bt gfu-bt--caption" }, [
                        _vm._v(
                          "available during Crowdfunding, Late Pledge, and Pledge Manager"
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "secondary",
                  fn: function () {
                    return [
                      _c("div", [_vm._v("Pledge Over Time")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "gfu-bt gfu-bt--caption" }, [
                        _vm._v("available during Crowdfunding only"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("base-compare-row", {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [_vm._v("Flexibility of Installments")]
                  },
                  proxy: true,
                },
                {
                  key: "primary",
                  fn: function () {
                    return [
                      _vm._v(
                        "Customizable number of installments and minimum order value"
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "secondary",
                  fn: function () {
                    return [
                      _vm._v(
                        "3 fixed installments, minimum order value of $125"
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("base-compare-row", {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [_vm._v("Tax Charging")]
                  },
                  proxy: true,
                },
                {
                  key: "primary",
                  fn: function () {
                    return [
                      _vm._v(
                        "During Crowdfunding, Late Pledge, and Pledge Manager"
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "secondary",
                  fn: function () {
                    return [_vm._v("Only in Pledge Manager")]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("base-compare-row", {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [_vm._v("Performance Marketing Support")]
                  },
                  proxy: true,
                },
                {
                  key: "primary",
                  fn: function () {
                    return [_vm._v("Internal team & Adfound")]
                  },
                  proxy: true,
                },
                {
                  key: "secondary",
                  fn: function () {
                    return [_vm._v("Internal team")]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("base-compare-row", {
              attrs: { highlighted: "both" },
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [_vm._v("Mobile App")]
                  },
                  proxy: true,
                },
                {
                  key: "primary",
                  fn: function () {
                    return [
                      _c("base-icon", {
                        staticClass: "_tc--accent",
                        attrs: { name: "check", size: "lg" },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "secondary",
                  fn: function () {
                    return [
                      _c("base-icon", {
                        staticClass: "_tc--accent",
                        attrs: { name: "check", size: "lg" },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("base-compare-row", {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [_vm._v("Endgame (crowdfunding campaign extension)")]
                  },
                  proxy: true,
                },
                {
                  key: "primary",
                  fn: function () {
                    return [
                      _c("base-icon", {
                        staticClass: "_tc--accent",
                        attrs: { name: "check", size: "lg" },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "secondary",
                  fn: function () {
                    return [
                      _c("base-icon", { attrs: { name: "times", size: "lg" } }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("base-compare-row", {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [_vm._v("Express crowdfunding")]
                  },
                  proxy: true,
                },
                {
                  key: "primary",
                  fn: function () {
                    return [
                      _c("base-icon", {
                        staticClass: "_tc--accent",
                        attrs: { name: "check", size: "lg" },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "secondary",
                  fn: function () {
                    return [
                      _c("base-icon", { attrs: { name: "times", size: "lg" } }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("base-compare-row", {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [_vm._v("Shipping Options in Pledge Manager")]
                  },
                  proxy: true,
                },
                {
                  key: "primary",
                  fn: function () {
                    return [
                      _vm._v(
                        "Multiple advanced models (by weight, quantity, and more)"
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "secondary",
                  fn: function () {
                    return [_vm._v("Limited options")]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("base-compare-row", {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [_vm._v("Homepage Project Visibility")]
                  },
                  proxy: true,
                },
                {
                  key: "primary",
                  fn: function () {
                    return [
                      _vm._v(
                        "Across all phases (Crowdfunding, Late Pledge, and Pledge Manager)\n                "
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "secondary",
                  fn: function () {
                    return [_vm._v("Limited to Crowdfunding")]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("base-compare-row", {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [
                      _vm._v(
                        "Estimated Average Tabletop Campaign Funding (2025)"
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "primary",
                  fn: function () {
                    return [_vm._v(_vm._s(_vm.$format(338394, "C2", "$")))]
                  },
                  proxy: true,
                },
                {
                  key: "secondary",
                  fn: function () {
                    return [_vm._v(_vm._s(_vm.$format(30623, "C2", "$")))]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("base-compare-row", {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [_vm._v("Estimated Total Tabletop Funding (2025)")]
                  },
                  proxy: true,
                },
                {
                  key: "primary",
                  fn: function () {
                    return [_vm._v(_vm._s(_vm.$format(189708000, "C2", "$")))]
                  },
                  proxy: true,
                },
                {
                  key: "secondary",
                  fn: function () {
                    return [_vm._v(_vm._s(_vm.$format(186027000, "C2", "$")))]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c("base-compare-row", {
              attrs: { last: "" },
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [_vm._v("YoY growth in Tabletop (24 v 25)")]
                  },
                  proxy: true,
                },
                {
                  key: "primary",
                  fn: function () {
                    return [_vm._v("19%")]
                  },
                  proxy: true,
                },
                {
                  key: "secondary",
                  fn: function () {
                    return [_vm._v("-18%")]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }